import { render, staticRenderFns } from "./departmentalPerformance.vue?vue&type=template&id=f58ae50c&scoped=true&"
import script from "./departmentalPerformance.vue?vue&type=script&lang=js&"
export * from "./departmentalPerformance.vue?vue&type=script&lang=js&"
import style0 from "./departmentalPerformance.vue?vue&type=style&index=0&id=f58ae50c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58ae50c",
  null
  
)

export default component.exports